import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { Employee, EmployeeFormBuilder } from 'src/app/feature-module/employees/models/Employee';
import { EmployeeService } from 'src/app/feature-module/employees/service/employee.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { StaticDictionaryService } from 'src/app/shared/services/static-dictionary.service';

@Component({
  selector: 'app-employe-add',
  templateUrl: './employe-add.component.html',
  styleUrls: ['./employe-add.component.scss']
})
export class EmployeeAddComponent extends DialogContentBase implements OnInit {
  constructor(public dialog: DialogRef, private fb: UntypedFormBuilder,
    private employeeService: EmployeeService, private staticDictionary: StaticDictionaryService,
    private formUtilsService: FormUtilsService, public uiNotification: UiNotificationService) {
    super(dialog);
  }

  addDataForm: UntypedFormGroup;
  addData: Employee;
  error: string;

  @Input() name:string;
  @Input() surname:string;

  ngOnInit(): void {

    this.addData = EmployeeFormBuilder.initEmployee();
    this.addData.name = this.name;
    this.addData.surname = this.surname
    this.addDataForm = EmployeeFormBuilder.getForm(this.fb, this.addData);
  }


  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm() {

    if (!this.formUtilsService.markFormGroupTouched(this.addDataForm)) {
      this.uiNotification.showValidationError();
      return;
    }

    Object.assign(this.addData, this.addDataForm.value);

    this.employeeService.storeEmployee(this.addData).subscribe(
      (r) => {
        this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
        this.dialog.close({ text: 'OK' , addedEmployeeId: r});
      });
  }
}
